import { PLATFORM_IDS, PLATFORMS, PLATFORM_OPTIONS, getPlatformConfig } from "./platforms.js";
import { createCustomAdapter } from "./adapters/custom.js";
import { createObsAdapter } from "./adapters/obs.js";
import { createTeamsAdapter } from "./adapters/teams.js";
import { createYouTubeAdapter } from "./adapters/youtube.js";
import { createZoomAdapter } from "./adapters/zoom.js";

export { PLATFORM_IDS, PLATFORMS, PLATFORM_OPTIONS, getPlatformConfig };

export function createLiveCaptionAdapter(config) {
    switch (config.platform) {
        case PLATFORM_IDS.YOUTUBE:
            return createYouTubeAdapter(config);
        case PLATFORM_IDS.ZOOM:
            return createZoomAdapter(config);
        case PLATFORM_IDS.TEAMS:
            return createTeamsAdapter(config);
        case PLATFORM_IDS.OBS:
            return createObsAdapter(config);
        case PLATFORM_IDS.CUSTOM:
            return createCustomAdapter(config);
        default:
            throw new Error(`Unsupported live captioning platform: ${config.platform}`);
    }
}
